import React from "react";
import TypingGame from "./TypingGame";
import {useIntl} from "react-intl";
import messages from "../../i18n/messages";
import RocketCountdownGame from "./RocketCountdownGame";

const LearnGame = () => {
    const intl = useIntl();
    return (
        <div>
            {intl.formatMessage(messages.gamePageInfo)}
            <br/>
            <br/>
            <TypingGame/>
            <br/>
            <hr/>
            <br/>
            <RocketCountdownGame/>
            <br/>
            <br/>
            <hr/>
        </div>
    );
}

export default LearnGame;